import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { isAdminStore, isStore } from '../Authetication'



export default function AdminStore() {


  let auth = {"token": isAdminStore()}

  

  return (
   auth.token ? <Outlet/> : <Navigate to="/dashboard"/>
  )
}
